import { type JSX, useState } from 'react';

import { type Repub } from '@cx-modules/types';

import { type LoadOutrightsCouponArgs } from '../../types';
import { type OutrightMarketDto } from '../_common';
import { OutrightMarkets } from '../outright-markets';

import { OutrightsWrapper } from './style';

export interface OutrightsProps {
  headerTitle?: string;
  oddsShown: LoadOutrightsCouponArgs['oddsShown'];
  outrightMarkets: OutrightMarketDto[];
  repub: Repub;
  requestUrl: string;
}

export const Outrights = ({ headerTitle, oddsShown, outrightMarkets, requestUrl }: OutrightsProps): JSX.Element => {
  const [newUI] = useState(true);

  const formattedMarkets = outrightMarkets.map(m => {
    const isWin = new RegExp(/win(?! the playoffs)\b/gi).test(m.marketName);

    let marketName = m.marketName;
    marketName = (marketName || '').replace('Grp.', 'Group');

    const url = isWin ? m.url?.replace('/win-market', '/winner') : m.url;

    return { ...m, marketName, url };
  });

  const [marketsWithBets] = formattedMarkets.reduce(
    (acc, market) => {
      const hasBets = Boolean(market.bets);
      acc[hasBets ? 0 : 1].push(market);
      return acc;
    },
    [new Array<OutrightMarketDto>(), new Array<OutrightMarketDto>()],
  );

  return (
    <OutrightsWrapper>
      <OutrightMarkets
        compactView={newUI}
        headerTitle={headerTitle}
        newUI={newUI}
        oddsShown={oddsShown}
        outrightMarkets={marketsWithBets}
        requestUrl={requestUrl}
        showAllOutrightsLink={!newUI}
      />
    </OutrightsWrapper>
  );
};
